import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const BadgeContainer = styled.View`
  height: ${RFValue(16)}px;
  border-radius: ${RFValue(5)}px;
  align-items: center;
  justify-content: center;
  padding: 0 ${RFValue(4)}px;
  border: 1px solid ${({theme}) => theme.colors.border};
`;

export const BadgeText = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(9.6)}px;
  line-height: ${RFValue(12)}px;
  text-align-vertical: center;
  font-family: ${({theme}) => theme.fonts.bold};
`;
